import React from 'react';
import { motion } from 'framer-motion';
import { User, Medal } from 'lucide-react';

interface WorkoutCoachProps {
  coach: {
    name: string;
    image: string;
    specialties: string[];
  };
}

export function WorkoutCoach({ coach }: WorkoutCoachProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <User className="w-5 h-5 text-primary" />
        <h2 className="font-semibold">Your Coach</h2>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-muted/30 p-4 rounded-lg flex items-center gap-4"
      >
        <img
          src={coach.image}
          alt={coach.name}
          className="w-16 h-16 rounded-full object-cover"
        />
        <div>
          <h3 className="font-medium">{coach.name}</h3>
          <div className="flex flex-wrap gap-2 mt-2">
            {coach.specialties.map((specialty, index) => (
              <div
                key={index}
                className="flex items-center gap-1 px-2 py-1 rounded-full bg-primary/10 text-primary text-xs"
              >
                <Medal className="w-3 h-3" />
                <span>{specialty}</span>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  );
}